import { Route, Routes } from 'react-router-dom';

import { SeasonalPlanDetail } from './SeasonalPlanDetail';
import { SeasonalPlansList } from './SeasonalPlansList';

interface SeasonalPlansProps {
  programType: string;
}

export function SeasonalPlans({ programType }: SeasonalPlansProps) {
  return (
    <Routes>
      <Route path="/" element={<SeasonalPlansList programType={programType} />} />
      <Route path="/:planGroupId" element={<SeasonalPlanDetail programType={programType} />} />
    </Routes>
  );
}
